import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import router from './routers'
import axios from 'axios'
import '@fortawesome/fontawesome-free/css/all.css';


axios.defaults.withCredentials = true;

createApp(App).use(router).mount('#app')
